import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

import 'react-tabs/style/react-tabs.css';
import "../landing-page.css";
import { LOGIN_DOMAIN } from "../Services/Configuration";
import Swal from "sweetalert2";
function NavigationServicesHeader() {
  let user = localStorage.getItem("username");
  if (user === "" || user === undefined || user === null) {
    Swal.fire({
      text: "Session Expired",
      icon: "error",
      confirmButtonText: "Ok",
      confirmButtonClass: "swal-button--confirm",
    }).then(function () {
      window.location = LOGIN_DOMAIN;
    });
  }

  // const handleLogOut = () => {
  //   Swal.fire({
  //     text: "Are You Sure Want to Sign Out?",
  //     icon: "question",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       // axiosTokenService.post(TOKEN_INVALIDATE_URL).then((res) => {
  //       //   if (res !== "" && res !== undefined && res !== null) {
  //       //     localStorage.removeItem("token");
  //       //     localStorage.removeItem("username");
  //       //     localStorage.removeItem("user");
  //       //     localStorage.clear();
  //       //     ClearLocalStorage();
  //       //     history.push("/LogOut");
  //       //   }
  //       // });
  //     }
  //   });
  // }

  return (
  <></>
  );
};

export default NavigationServicesHeader;
